export const sleep = async (ms: number) =>
  new Promise((cb) => {
    setTimeout(cb, ms);
  });
